module.exports = __webpack_public_path__ + "images/marketing/peeps/nick_bertolino.jpg";